// @services/ReportedReview/GetRejectedReviewsService.ts
import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'
import { ReportedReview } from './GetReportedReviewsService'

export class RejectedReviewsService {
  async getRejectedReviews(): Promise<ReportedReview[]> {
    const api = new ScrubstrApiQueryService()

    // call the API - axios already parses JSON, so response is the array directly
    const data = await api.get<ReportedReview[]>({
      endpoint: 'admin/reviews/rejected-reviews',
    })

    // Ensure we return an array
    return Array.isArray(data) ? data : []
  }
}
